import React, { useEffect } from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
  } from "@progress/kendo-react-grid";
  import { useState } from "react";
  import { orderBy, SortDescriptor } from "@progress/kendo-data-query";
  import { useNavigate } from "react-router-dom";
  import { checkStatus } from "../../utils/EllowUtils";
  import { Icon } from "@iconify/react";



function RatingTable(Props: any) {

  const ViewButton = (props: GridCellProps) => {

    const sendReminder = (data: any) => {
      let body = {          
        "requestId": data.assessment_request_id,
        "submittedBy":"FREELANCER"          
      }
      Props.sendReminder(body)
    }
   
    return (
      <td>
        <button type="button" className="applyButton" onClick={() => sendReminder(props.dataItem)} >
            Send Reminder
        </button>
      </td>
    );
  }

    return (
        <Grid
            data={Props.data}
            sortable={true}
        >    
        <GridNoRecords>
            <div className="noData">
              <Icon icon="mdi:smiley-neutral-outline" />
              No data to display
            </div>
          </GridNoRecords>
        <Column field="requestedDate" title="Requested Date" className="break-all" cell={requestedDateCell}/>
        <Column field="email" title="Email" className="break-all" cell={emailCell}/>
        <Column field="company" title="Company" className="break-all" cell={companyCell}/>    
        <Column field="myRole" title="My Role" className="break-all" cell={roleCell}/>
        <Column field="status" title="Status" className="break-all" cell={statusCell}/> 
        <Column field="resent" title="Resent on" className="break-all" cell={resentCell}/>
        <Column cell={ViewButton}  width="120px" />
    </Grid>
  )
}

export default RatingTable

const requestedDateCell = (props: GridCellProps) => {
   
    let dateNumber = parseInt(props.dataItem.requested_on)
    let date = new Date(dateNumber).toDateString();
    return (
      <td >
         <div className="dateWrap">
            {date}
        </div>
      </td>
    )
  }

  const emailCell = (props: GridCellProps) => {
  
    return (
      <td >
         <div className="email">
            {props.dataItem.requested_to_email}
        </div>
      </td>
    )
  }

  const companyCell = (props: GridCellProps) => {
  
    return (
      <td >
        <div className="userInfo">
            {props.dataItem.company_name}
        </div>
      </td>
    )
  }

  const roleCell = (props: GridCellProps) => {
  
    return (
      <td >
        <div className="userInfo">
            {props.dataItem.candidate_role}
        </div>
      </td>
    )
  }

  const statusCell = (props: GridCellProps) => {
    
    return (
      <td >
        <div className={checkStatus(props.dataItem.request_status)}>
            {props.dataItem.request_status}
        </div>
      </td>
    )
  }


  const  resentCell = (props: GridCellProps) => {
    
    let dateNumber = parseInt(props.dataItem.resent_on)
    let date = props.dataItem.resent_on ? new Date(dateNumber).toDateString() : '';
    
    return (
      <td >
        <div className="dateWrap">
            {date}  
        </div>
      </td>
    )
  }

  